<template>
  <div class="fixed top-4 right-4 flex flex-col gap-3 z-50">
    <div
      v-for="n in store.notifications"
      :key="n.id"
      class="w-80 p-4 rounded-lg shadow-lg text-white animate-fade-in"
      :class="{
        'bg-blue-500': n.type === 'info',
        'bg-yellow-500': n.type === 'warning',
        'bg-red-600': n.type === 'critical'
      }"
    >
      <div class="flex justify-between items-center mb-1">
        <h4 class="font-bold">{{ n.title }}</h4>
        <button @click="store.remove(n.id)" class="text-white/80 hover:text-white">
          ✕
        </button>
      </div>
      <p class="text-sm">{{ n.message }}</p>
    </div>
  </div>
</template>

<script setup>
import { useNotificationStore } from "@/stores/notification";

const store = useNotificationStore();
</script>

<style scoped>
@keyframes fade-in {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
.animate-fade-in {
  animation: fade-in 0.2s ease-out;
}
</style>
